import { render, staticRenderFns } from "./aiTopic.vue?vue&type=template&id=44d6dabe"
import script from "./aiTopic.vue?vue&type=script&lang=js"
export * from "./aiTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports